export default {
    InternalOrder: {
        ps1: '提醒：根据仓库实际订单处理情况，任何订单的取消或修改可能无法成功。',
        ps2: '请先录入订单的物流信息。',
        Common: '常用查询：',
        JobID: '运单号',
        CourierName: '物流商',
        byorder: '手工下载授权渠道订单',
        No: '订单号',
        number: '客户订单号/内部订单号',
        store: '提货店铺',
        Sales: '销售员工',
        Method: '提货方式',
        Receiving: '收货状态',
        Doc: '物流单号',
        Email: '邮件地址',
        orderCode: '订单创建时间',
        ERP: 'ERP超时单',
        SAP: 'SAP超时单',
        WMS: 'WMS超时单',
        SKU: 'SKU编码',
        source: '订单来源',
        there: '有无赠品',
        nickname: '买家昵称',
        name: '收货人姓名',
        phone: '收货人手机',
        Buyer: '买家备注',
        Merchant: '商家备注',
        Label: '标签',
        Aggregation: '聚合状态：',
        Shipment: '发货状态',
        status: '收货状态',
        occupied: '预占状态',
        Sourcing: '寻源状态',
        Pending: '挂起状态',
        Pre: '预占回写状态',
        update: '发货回写状态',
        Time: '时间查询：',
        order: '三方下单时间',
        orderOFF: '关单时间',
        orderStart: '三方下单开始时间',
        orderEnd: '三方下单结束时间',
        InternalStart: '内部创单开始时间',
        InternalEnd: '内部创单结束时间',
        EstimatedStart: '预计发货开始时间',
        EstimatedEnd: '预计发货结束时间',
        Start: '开始日期',
        End: '结束日期',
        Payment: '支付时间',
        Internal: '内部创单时间',
        Estimated: '预计发货时间',
        Shipmen: '发货时间',
        Confirm: '确认收货时间',
        Amount: '金额查询：',
        Total: '商品总金额',
        Minimum: '最小金额',
        Maximum: '最大金额',
        payable: '买家应付金额',
        cost: '商品总成本',
        All: '全部',
        create: '创建订单',
        Product: '商品信息',
        form: {
            number: '客户订单号',
            Internal: '内部订单号',
            err: '失败原因',
            Timeout: '超时时长（小时）',
            sapOrderNo: 'SAP订单号',
            wmsOrderNo: 'WMS订单号',
            orderStatusStr: '订单状态',
            pickUpTime: '是否提货',
            OriginalInternal: '原内部订单号',
            Label: '标签',
            Sales: '销售店铺',
            channel: '销售渠道',
            employee: '销售员工',
            store: '提货店铺',
            Source: '订单来源',
            Product: '商品行数量',
            nickname: '买家昵称',
            comments: '买家备注',
            Merchant: '商家备注',
            Method: '提货方式',
            name: '收货人姓名',
            phone: '收货人手机号',
            address: '收货人地址',
            Shipment: '发货状态',
            document: '物流单号',
            status: '收货状态',
            Total: '商品总金额',
            Buyer: '买家应付',
            cost: '商品总成本',
            placement: '三方下单时间',
            time: '支付时间',
            creation: 'ERP创单时间',
            delivery: '预计发货时间',
            Pre: '预占状态',
            Sourcing: '寻源状态',
            Pending: '挂起状态',
            emptive: '预占回写状态',
            Update: '发货回写状态',
            there: '有无赠品',
            Delete: '是否删除？',
            AbnormalCause: '异常原因',
            sapPushTime: 'SAP推送时间',
            sapPullTime: 'SAP处理时间',
            hjPushTime: 'HJ推送时间',
            hjLockTime: 'HJ锁定时间',
            hjShipmentTime: 'HJ发货时间',
            ERPCard: 'ERP 卡单间隔 (小时)',
            SAPCard: 'SAP 卡单间隔 (小时)',
            HJCard: 'WMS 卡单间隔 (小时)',
            tab: '有效订单',
            hjOrderStatus: 'HJ订单状态',
            sapOrderStatus: 'SAP订单状态',
        },
        AddException: '加入异常单',
        ReleaseException: '解除异常单',
        ReleaseExceptions: '解除异常单',
        LogisticsInformationExport: '物流信息导出',
        failure: '点击查看失败原因',
        unshipped: '未发货',
        UnableToTakeDelivery: '无法提货',
        Reason: '预占失败原因',
        Exit: '离场风险',
        Mega: '特大订单',
    }
};
